export default "__VITE_ASSET__611ca593__"